import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import coreTokens from '@/core/tokens.json';

function PortalLogoExpanded() {
  return (
    <picture>
      <source type="image/webp" srcSet="/assets/logo-large.webp" />
      <img
        src="/assets/logo-large.png"
        width="200"
        height="85"
        alt={coreTokens['NAVIGATE_HOME']}
        loading="lazy"
        decoding="async"
      />
    </picture>
  );
}

function PortalLogoCollapsed() {
  return (
    <picture>
      <source type="image/webp" srcSet="/assets/logo-small.webp" />
      <img
        src="/assets/logo-small.png"
        width="34"
        height="34"
        alt={coreTokens['NAVIGATE_HOME']}
        loading="lazy"
        decoding="async"
      />
    </picture>
  );
}

interface PortalLogoProps extends BoxProps {
  variant: 'expanded' | 'collapsed';
}

function PortalLogo({ variant, ...props }: PortalLogoProps) {
  return variant === 'collapsed' ? (
    <PortalLogoCollapsed />
  ) : (
    <Box display="flex" flexDirection="column" alignItems="center" pb={2} {...props}>
      <PortalLogoExpanded />
    </Box>
  );
}

export default PortalLogo;
